import { SkeletonRows } from "@bafe/ui";
import type { UseQueryResult } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { ErrorPanel } from "./ErrorPanel";

export interface QueryStateProps<T> {
	query: UseQueryResult<T, Error>;
	/** Stable-height placeholder so content does not jump when it arrives. */
	loading?: ReactNode;
	errorTitle?: string;
	children: (data: T) => ReactNode;
}

/** The loading / error / content triad every list and detail screen needs. */
export function QueryState<T>({ query, loading, errorTitle, children }: QueryStateProps<T>) {
	if (query.isPending) return <>{loading ?? <SkeletonRows rows={4} />}</>;

	if (query.isError) {
		return (
			<ErrorPanel
				error={query.error}
				title={errorTitle}
				onRetry={() => void query.refetch()}
				retryPending={query.isFetching}
			/>
		);
	}

	return <>{children(query.data)}</>;
}
